<template>
  <div class="app-auto-top-up-wrapper" v-if="showComponent">
    <slot name="txtBefore"></slot>
    <slot v-if="activated" name="txtSuccessActivate"><div class="success">Automatische Aufladung eingerichtet</div></slot>
    <slot v-if="deactivated" name="txtSuccessDectivate"><div class="success">Automatische Aufladung deaktiviert</div></slot>
    <NoPaymentDataView v-if="showMissingPayment" :url="paymentUrl">
      <template v-for="slot in possibleChildSlotsFor('MissingPayment')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </NoPaymentDataView>
    <CurrentAutoTopUp v-if="showCurrentTopUp" :top-up="autoTopUp.topUp">
      <template v-for="slot in possibleChildSlotsFor('CurrentTopUp')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </CurrentAutoTopUp>
    <SelectAutoTopUpType
      v-if="showTopUpSelection"
      :saved-top-up="autoTopUp.topUp"
      :auto-amounts="topUpAmounts.autoAmounts">
      <template v-for="slot in possibleChildSlotsFor('SelectTopUpType')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SelectAutoTopUpType>
    <ActivateAutoTopUpSummary
      v-if="showActivateTopUpSummary"
      :payment="autoTopUp.paymentType"
      :url="paymentUrl">
      <template v-for="slot in possibleChildSlotsFor('Activate')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ActivateAutoTopUpSummary>
    <DeactivateAutoTopUpSummary
      v-if="showDeactivateTopUpSummary"
      :topUp="autoTopUp.topUp">
      <template v-for="slot in possibleChildSlotsFor('Deactivate')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </DeactivateAutoTopUpSummary>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

import NoPaymentDataView from '@/components/process/generic/TopUp/SingleTopUp/NoPaymentDataView.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import slotProxy from '../../../../../../mixins/slotProxy'
import CurrentAutoTopUp from '@/components/process/generic/TopUp/ChangeAutoTopUp/fyve/CurrentAutoTopUp.vue'
import SelectAutoTopUpType from '@/components/process/generic/TopUp/ChangeAutoTopUp/fyve/SelectAutoTopUpType.vue'
import ActivateAutoTopUpSummary from '@/components/process/generic/TopUp/ChangeAutoTopUp/fyve/ActivateAutoTopUpSummary.vue'
import DeactivateAutoTopUpSummary from '@/components/process/generic/TopUp/ChangeAutoTopUp/fyve/DeactivateAutoTopUpSummary.vue'

export default {
  name: 'AutoTopUpWrapper',
  components: {
    ActivateAutoTopUpSummary,
    SelectAutoTopUpType,
    CurrentAutoTopUp,
    NoPaymentDataView,
    DeactivateAutoTopUpSummary
  },
  data () {
    return {
      deactivated: false,
      activated: false,
      autoTopUp: {
        active: false,
        activationPossible: false,
        amounts: {
          amount: [],
          default: null
        },
        topUp: null,
        paymentType: null
      },
      topUpAmounts: {
        autoAmounts: {
          monthly: {
            amount: [],
            default: 0
          },
          threshold: {
            amount: [],
            default: 0,
            trigger: [],
            defaultTrigger: 0
          }
        }
      }
    }
  },
  mounted () {
    if (this.currentStep === 'success') {
      this.reset()
    }
  },
  watch: {
    currentStep (newValue, oldValue) {
      if (oldValue === 'deactivateTopUpSummary' && newValue === 'success') {
        this.deactivated = true
      } else if (oldValue === 'activateTopUpSummary' && newValue === 'success') {
        this.activated = true
      } else {
        this.activated = false
        this.deactivated = false
      }
      if (newValue === 'success') {
        this.$apollo.queries.autoTopUpStatus.refetch()
      }
    }
  },
  computed: {
    showComponent () {
      return this.$apolloData.loading === 0
    },
    showTopUpSelection () {
      return this.autoTopUp.activationPossible === true && (this.currentStep === 'amountSelect' || this.currentStep === 'success')
    },
    showCurrentTopUp () {
      return this.autoTopUp.activationPossible === true && (this.currentStep === 'amountSelect' || this.currentStep === 'success')
    },
    showActivateTopUpSummary () {
      return this.autoTopUp.activationPossible === true && this.currentStep === 'activateTopUpSummary'
    },
    showDeactivateTopUpSummary () {
      return this.autoTopUp.activationPossible === true && this.currentStep === 'deactivateTopUpSummary'
    },
    showMissingPayment () {
      return this.autoTopUp.paymentType === null
    },
    ...mapGetters([
      'brand'
    ]),
    ...mapGetters('topUp/auto', [
      'currentStep'
    ])
  },
  methods: {
    ...mapMutations('topUp/auto', [
      'reset'
    ])
  },
  props: {
    paymentUrl: {
      type: String,
      default: '#'
    }
  },
  mixins: [
    slotProxy(),
    transaction('autoTopUp')
  ],
  apollo: {
    autoTopUpStatus: function () {
      return wrapQuery(
        gql`query autoTopUp($brand: String!) {
          autoTopUp {
            active
            activationPossible
            topUp {
              amount
              trigger
              type
            }
            paymentType {
              ...on BankAccount {
                type
                iban
                owner
              }
              ...on CreditCard {
                type
                holder
                company
                expiryMonth
                expiryYear
                lastDigits
              }
            }
          }
          topUpAmounts(brand: $brand) {
              autoAmounts {
                monthly {
                  amount
                  default
                }
                threshold {
                  amount
                  default
                  trigger
                  defaultTrigger
                }
              }
            }
        }`, this, ['autoTopUp', 'topUpAmounts'], { brand: this.brand }, null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  }
}
</script>
